<div class="comment-add-dialog-layout">
  <div class="title-div">
    <h1 mat-dialog-title>Ajouter un commentaire</h1>
  </div>

  <div class="tv-ns-custom-horizontal-divider"></div>

  <div class="add-dialog-container">
    <div class="tv-container-hour-input">
      <div class="name-date">
        <div class="tv-rect-input-extensible input-prenom">
          <mat-form-field>
            <mat-label>Auteur</mat-label>
            <input matInput [(ngModel)]="comment.author" disabled />
          </mat-form-field>
        </div>

        <div class="tv-rect-input-extensible input-date">
          <mat-form-field>
            <mat-label>Date</mat-label>
            <input matInput [(ngModel)]="formattedCommentDate" disabled />
          </mat-form-field>
        </div>

        <div class="tv-container-select-white-rect-extensible input-date">
          <mat-form-field>
            <mat-label>Type</mat-label>
            <mat-select panelClass="tv-custom-always-visible-scroll-bar" [(ngModel)]="comment.type">
              <mat-option *ngFor="let t of commentTypes" class="tv-ns-select-option" [value]="t.value">{{ t.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="tv-rect-textarea full-width input-format input-body">
        <mat-form-field>
          <mat-label>Corps</mat-label>
          <textarea matInput class="textarea-body" [(ngModel)]="comment.body" rows="4"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="button-container">
    <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancel()">Annuler</button>
    <button class="tv-ns-validation-large-button" (click)="onAddComment()">Ajouter</button>
  </div>
</div>
